<template>
  <div class="oppor-page" v-loading="infoLoading">
    <el-table
      :data="tableData"
      border
      class="table"
      header-row-class-name="head"
    >
      <el-table-column
        prop="businessName"
        label="商机标题"
        width="180">
      </el-table-column>
      <el-table-column
        prop="preOrderDate"
        label="预计签单时间"
        width="180">
      </el-table-column>
      <el-table-column
        prop="preOrderAmount"
        label="预计成单金额">
      </el-table-column>
      <el-table-column
        prop="businessProg"
        label="跟进状态">
      </el-table-column>
      <el-table-column
        prop="serviceStageName"
        label="项目类型">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  opportunityList,
  // opportunityUpdate
} from '@/service/customerInformation.js';
export default {
  data(){
    return{
      infoLoading: false,
      tableData:[],
    }
  },
  mounted() {
    this.loadList();
  },
  methods: {
    loadList(){
      let data = {
        custId: this.$route.query.custId
      }
      this.infoLoading = true
      opportunityList(data).then(r=>{
        this.infoLoading = false
        if(r.Result==1){
          this.tableData=r.Data.datas ||[];
        }
      })
    },
  },
}
</script>
<style lang="scss">
.oppor-page{
  .table{
    width: 100%;
    .head th{
      background-color: #f9f9f9;
    }
  }
}
</style>